import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule, MatLabel } from '@angular/material/form-field';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';

import { AppService } from '@app/app.service';
import { MatCheckbox } from "@angular/material/checkbox";

@Component({
  selector: 'app-template-dialog',
  standalone: true,
  imports: [
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatButtonModule,
    MatInputModule,
    MatFormFieldModule,
    MatLabel,
    ReactiveFormsModule,
    MatCheckbox
],
  templateUrl: './template-dialog.component.html',
  styleUrl: './template-dialog.component.scss',
})
export class TemplateDialogComponent implements OnInit {
  form!: FormGroup;
  dialogTitle: string = '';
  addButtonLabel: string = '';
  templateType: string = '';

  constructor(
    public dialogRef: MatDialogRef<TemplateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private appService: AppService
  ) {
  }

  ngOnInit(): void {
    this.form = this.fb.group({
      name: ['', [Validators.required]],
      save_origin: [true],
    });

    this.patchForm();

    if (this.data && this.data.mode === 'create') {
      this.dialogTitle = 'New Template';
      this.addButtonLabel = 'Add';
    }

    if (this.data && this.data.mode === 'update' && this.data.name) {
      this.dialogTitle = 'Update Template';
      this.addButtonLabel = 'Update';
    }

    if (this.data && this.data.mode === 'copy' && this.data.name) {
      this.dialogTitle = 'Copy Template';
      this.addButtonLabel = 'Copy';
    }

    this.templateType = this.data.type || null;

  }

  patchForm(): void {
    if (this.data && this.data.name && this.data.mode !== 'create') {
      this.form.patchValue({
        name: this.data.name,
      });
    }
  }

  submit(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      this.appService.showSnackBar('Please fill all required fields', 'error');
      return;
    }

    // merge updated fields back to original data
    this.dialogRef.close({ ...this.data, ...this.form.value });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
